import {TRootState} from "types";

export const isLastBulkImportReportDataLoadingSelector = (state: TRootState) =>
	state.backgroundTask.isLastBulkImportReportDataLoading;

export const activeLastCandidateAssessmentForProjectSelector = (state: TRootState) =>
	state.backgroundTask.activeCandidateAssessmentForProject;

export const bulkProfileImportsSelector = (state: TRootState) =>
	state.backgroundTask.bulkLinkedinProfileImports;

/** @deprecated Use bulkProfileImportsSelector instead */
export const profilesImportsByLinkedInSelector = bulkProfileImportsSelector;

export const candidateAssessmentRequestCreateInProgressSelector = (state: TRootState) =>
	state.backgroundTask.candidateAssessmentRequestCreateInProgress;
